export const APP_LINKS = {
    playStore: "https://play.google.com/store/apps/details?id=pro.itengo.itengo",
    appStore: "https://apps.apple.com/in/app/itengo/id6743934810"
};
